module.exports = __webpack_public_path__ + "img/4-housing.41211be2.png";